// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__WdMXk","actionsCol":"EnrolledClinics_actionsCol__1i3Gg"};